import { MainAttachments as MainAttachmentsSkeleton } from '@/deskUiSkeletons/Page/MainAttachments'
import { mainAttachmentsSkin } from './MainAttachmentsSkin'

// Std binding of the shared main-attachments skeleton: structure is shared,
// the look comes from this surface's skin tokens.
export function MainAttachments() {
  return <MainAttachmentsSkeleton skin={mainAttachmentsSkin} />
}
